import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { DatatableComponent, DataTablePagerComponent } from '@swimlane/ngx-datatable';
import { SpringDatatablePagination } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination';
import { SpringDatatablePaginationService } from '../../../shared/services/spring-integration/pagination/spring-datatable-pagination.service';
import { DatatableService } from '../../../shared/services/datatable.service';
import { HttpParams } from '@angular/common/http';
import { NgxSpinnerService } from 'ngx-spinner';
import { NotificationsService } from 'angular2-notifications';
import { AssociacoesService } from './associacoes.service';
import { ModalAlteracaoAssociacaoComponent } from './modal-alteracao-associacao/modal-alteracao-associacao.component';
import { NbDialogService } from '@nebular/theme';
import { DocumentoHelper } from '../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-associacoes',
  templateUrl: './associacoes.component.html',
  styleUrls: ['./associacoes.component.scss']
})
export class AssociacoesComponent implements OnInit {

  @ViewChild('myTable', { static: false })
  public myTable: DatatableComponent;

  @ViewChild('tablePager', { static: false })
  public tablePager: DataTablePagerComponent;

  public formAssociacaoSplitVendas = null;
  public tableLimit = 20;
  public rowData = null;
  public tipo = null;
  public cnpjCpf = null;
  public customLogin = null;

  public datatablePagination: SpringDatatablePagination = new SpringDatatablePagination();

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private paginationService: SpringDatatablePaginationService,
    private datatableService: DatatableService,
    private service: AssociacoesService,
    private spinnerService: NgxSpinnerService,
    private notifications: NotificationsService,
    private activatedRoute: ActivatedRoute,
    private dialogService: NbDialogService,
  ) {

    this.rowData = [];

    this.paginationService.setDatatablePagination(this.datatablePagination);

    this.tipo = [
      {
        status: 'ATIVO',
        descricao: 'ATIVO'
      },
      {
        status: 'INATIVO',
        descricao: 'INATIVO'
      },
      {
        status: 'SUSPENSO',
        descricao: 'SUSPENSO'
      },

    ];

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;
    this.datatableService.subscribeTable(this.myTable);

    this.formAssociacaoSplitVendas = this.formBuilder.group({
      cnpjCpf: [null],
      nomeFantasia: [null],
      status: [null],

    });

  }

  ngOnDestroy() {
    this.datatableService.unsubscribeTable(this.myTable);
  }

  buscarUser(data: any, page?: any) {

    let params = new HttpParams();

    if (data != null) {

      if (data.status != null && String(data.status).trim() !== '') {
        params = params.append('status', data.status);
      }
      const docNorm = this.normalizarCnpjCpfParaBackend(data.cnpjCpf);
      if (docNorm !== '') {
        params = params.append('cnpjCpf', docNorm);
      }
      if (data.nomeFantasia != null && String(data.nomeFantasia).trim() !== '') {
        params = params.append('nomeFantasia', data.nomeFantasia);
      }

    }

    const pageParam =
      page != null && page !== undefined && page !== '' && !isNaN(Number(page))
        ? Number(page)
        : 1;
    params = params.append('page', String(pageParam));

    params = params.append('size', String(this.tableLimit));

    this.spinnerService.show();

    this.service.partnerSearch(params, (response => {

      this.datatablePagination.rowData = response.list;
      this.paginationService.setInfo(response);
      this.spinnerService.hide();

    }), error => {

      this.spinnerService.hide();
      this.notifications.error(error.message);

      if (error.status == 400) {
        this.datatablePagination.rowData = [null];
        this.datatablePagination.totalElements = 0;
      }
    });

  }

  gotoEdit(data: any) {

    this.dialogService.open(ModalAlteracaoAssociacaoComponent, {
      context: {
        razaoSocial: data.razaoSocial,
        cnpjCpf: this.normalizarCnpjCpfParaBackend(data.cnpj),
        editar: "EDITAR"
      },
    });

  }

  gotoCadastrar() {

    this.dialogService.open(ModalAlteracaoAssociacaoComponent, {
      context: {
        cadastrar: "CADATRAR",
      },
    });

  }

  gotoInativar(data) {

    let register = {

      cnpjCpf: this.normalizarCnpjCpfParaBackend(data.cnpj)

    };

    this.service.inactivatePartner(
      register,
      (response) => {
        this.notifications.success(response.message);
        this.buscarUser(this.formAssociacaoSplitVendas.value, this.tablePager._page);
      }, (error) => {
        this.notifications.error(error.message);
      });


  }

  getCpfCnpjMask(): string {
    const ctrl = this.formAssociacaoSplitVendas && this.formAssociacaoSplitVendas.get('cnpjCpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjCpf != null && String(this.cnpjCpf).trim() !== ''
        ? this.cnpjCpf
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  formatarDocumento(valor: string | null | undefined): string {
    return DocumentoHelper.formatarDocumento(valor);
  }

  previousPage() {
    this.router.navigate(['/iot-dashboard']);
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) {
      return '';
    }
    const str = String(value);
    if (str === '') {
      return '';
    }
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }
}
